"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

/**
 * @ignore - internal component.
 */
var Tablelvl2Context = /*#__PURE__*/React.createContext();

if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

var _default = Tablelvl2Context;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Table/Tablelvl2Context.js
// module id = 141
// module chunks = 0